import { createNamespace } from '../utils';
import Row from '../row';
import Divider from '../divider';

var _createNamespace = createNamespace('text-box'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    type: {
      type: String,
      default: '1'
    },
    cover: String,
    title: String,
    content: String,
    subTitle: [String, Array],
    tip: String,
    subContent: [String, Array]
  },
  render: function render() {
    var h = arguments[0];
    var type = this.type,
        slots = this.slots,
        title = this.title,
        content = this.content,
        subTitle = this.subTitle,
        subContent = this.subContent,
        tip = this.tip,
        cover = this.cover;

    var subContent4 = function subContent4(ele) {
      return h("div", {
        "class": bem('sub-content')
      }, [typeof ele === 'string' ? h("div", {
        "class": bem('sub-content-item')
      }, [ele]) : ele.map(function (item, index) {
        return h("span", {
          "class": bem('sub-content-item')
        }, [item, h("i", {
          "directives": [{
            name: "show",
            value: index !== ele.length - 1
          }],
          "class": bem('gap')
        })]);
      })]);
    };

    switch (type) {
      case '1':
        return h("div", {
          "class": bem(['box1'])
        }, [slots('title') || title && h("div", {
          "class": [bem('title'), 'van-ellipsis']
        }, [title]), slots('content') || content && h("div", {
          "class": bem('content')
        }, [content]), slots('default')]);

      case '2':
        return h("div", {
          "class": bem(['box2'])
        }, [h(Row, {
          "attrs": {
            "type": "flex"
          }
        }, [slots('cover') || cover && h("img", {
          "attrs": {
            "src": cover
          },
          "class": bem('cover')
        }), h("div", {
          "class": bem('content-wrapper')
        }, [slots('title') || title && h("div", {
          "class": [bem('title'), 'van-multi-ellipsis--l1']
        }, [title]), slots('content') || content && h("div", {
          "class": [bem('content'), 'van-multi-ellipsis--l1']
        }, [content]), h(Row, {
          "attrs": {
            "type": "flex",
            "align": "center",
            "justify": "space-between"
          },
          "class": bem('sub-content-wrapper')
        }, [subContent && h("div", {
          "class": bem('sub-content')
        }, [subContent]), slots('tip') || tip && h("div", {
          "class": bem('tip')
        }, [tip])]), slots('default')])])]);

      case '3':
        return h("div", {
          "class": bem(['box3'])
        }, [h(Row, {
          "attrs": {
            "type": "flex",
            "align": "center",
            "justify": "space-between"
          }
        }, [h(Row, {
          "attrs": {
            "type": "flex",
            "align": "center"
          }
        }, [slots('cover') || cover && h("img", {
          "attrs": {
            "src": cover
          },
          "class": bem('cover')
        }), slots('title') || title && h("span", {
          "class": [bem('title'), 'van-multi-ellipsis--l1']
        }, [title]), subTitle && h("span", {
          "class": [bem('sub-title'), 'van-multi-ellipsis--l1']
        }, [subTitle])]), slots('tip') || tip && h("div", {
          "class": bem('tip')
        }, [tip])]), slots('content') || content && h("div", {
          "class": [bem('content'), 'van-multi-ellipsis--l2']
        }, [content]), slots('default')]);

      case '4':
        return h("div", {
          "class": bem(['box4'])
        }, [slots('cover') || cover && h("div", {
          "class": bem('cover-wrapper')
        }, [h("img", {
          "attrs": {
            "src": cover
          },
          "class": bem('cover')
        })]), slots('title') || h("div", {
          "class": [bem('title'), 'van-ellipsis']
        }, [title]), subTitle && (typeof subTitle === 'string' ? h("div", {
          "class": bem('sub-item')
        }, [h("div", {
          "class": bem('sub-title')
        }, [subTitle]), subContent4(subContent)]) : subTitle.map(function (item, i) {
          return h("div", {
            "class": bem('sub-item')
          }, [i > 0 && h(Divider, {
            "attrs": {
              "dashed": true,
              "margin": 15
            }
          }), h("div", {
            "class": bem('sub-title')
          }, [item]), subContent instanceof Array && subContent4(subContent[i])]);
        })), slots('default')]);

      case '5':
        return h("div", {
          "class": bem(['box5'])
        }, [h(Row, {
          "attrs": {
            "type": "flex",
            "align": "center",
            "justify": "space-between"
          },
          "class": bem('header')
        }, [subTitle && h("div", {
          "class": [bem('sub-title'), 'van-multi-ellipsis--l1']
        }, [subTitle]), slots('tip') || tip && h("span", {
          "class": [bem('tip'), 'van-multi-ellipsis--l1']
        }, [tip])]), h(Divider), h(Row, {
          "attrs": {
            "type": "flex"
          },
          "class": bem('content-wrapper')
        }, [slots('cover') || cover && h("img", {
          "attrs": {
            "src": cover
          },
          "class": bem('cover')
        }), h("div", [slots('title') || title && h("div", {
          "class": [bem('title'), 'van-multi-ellipsis--l1']
        }, [title]), slots('content') || content && h("div", {
          "class": bem('content')
        }, [content])])]), slots('default')]);
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/text-box/index.js
// module id = null
// module chunks = 